//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import customer from '@/customer'

export default {
  name: 'login',
  data () {
    return {
      account: '',
      password: '',
      checkLogin:false,
    }
  },
  created(){
    // this.$func.setLocal('token','');
    // this.$func.setLocal('node_v1','');
    // this.$func.setLocal('grade','');
    if(!this.$func.getLocal('token')){
      this.getCode();
    }else{
      // this.checkCid();
      this.checkCid();
    }
  },
  methods:{
     getCode(){
      var local = window.location.href
      this.code = this.getUrlCode().code 
      var appid = customer.appId;
      if (this.code == null || this.code === '') {
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
      } else {
        this.login();
      }
    },
    getUrlCode() {
      var url = window.location.href
      var theRequest = new Object()
      if (url.indexOf("?") != -1) {
         var urls = url.split("?")
          var strs = urls[1].split("&")
          for(var i = 0; i < strs.length; i++) {
              theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
          }
      }
      var code = theRequest.code;
      if(code == 'undefined' || code == null || code === ''){
        this.$func.setLocal('channel',parseInt(theRequest.channel));
      }
      return theRequest
    },
    login(){
        this.$api.login({code:this.code,channel:this.$func.getLocal('channel')}).then((res)=>{
          if(res){
            if(res.data.token){
              this.$func.setLocal('token',res.data.token);
              this.$func.setLocal('grade',res.data.grade);
              this.$func.setLocal('node_v1','');
              if (res.data.cid) {
                this.$func.setLocal('cid', res.data.cid);
              }
              if(parseInt(res.data.cid) > 0 ){
                this.getAccess();
              }else{
                this.checkLogin = true;
              }
            }
          }
        })  
    },
    checkCid(){
      this.$api.checkCid({}).then((res)=>{
        if(res.code == 2){
          if(customer.enableRegionManager && parseInt(this.$func.getLocal('grade')) === 2 && this.$func.getLocal('store_list')){
            this.$router.replace({path:'/selectStore'});
            return false;
          }
          this.checkLogin = true;
          // this.$func.showToast(res.msg);
          return false;
        }else{
          this.syncUserInfo(()=>{
            this.getAccess();
          });
        }
      })
    },
    submit(){
        let that = this;
        if (!that.account) {
            that.$func.showToast('请输入账号');
            return false;
        }
        if (!that.password) {
            that.$func.showToast('请输入密码');
            return false;
        }
        that.$api.loginCommunity({
            account: that.account,
            password: that.password,
        }).then((res)=>{
          if(res){
            that.$func.setLocal('grade',res.data.grade);
            that.$func.setLocal('node_v1','');
            if (customer.enableRegionManager && parseInt(res.data.need_store_select) === 1 && Array.isArray(res.data.store_list) && res.data.store_list.length) {
              that.$func.setLocal('store_list', JSON.stringify(res.data.store_list));
              that.$func.setLocal('cid', '');
              that.$router.replace({path:'/selectStore'});
              return;
            }
            if (res.data.cid) {
              that.$func.setLocal('cid', res.data.cid);
            }
            if (res.data.store_list) {
              that.$func.setLocal('store_list', JSON.stringify(res.data.store_list));
            }
            that.getAccess();
          }
        });
    },
    syncUserInfo(callback){
      this.$api.getInfo({}).then((res)=>{
        if(res && res.data){
          if(res.data.token){
            this.$func.setLocal('token',res.data.token);
          }
          if(res.data.grade){
            this.$func.setLocal('grade',res.data.grade);
          }
          if(res.data.cid){
            this.$func.setLocal('cid',res.data.cid);
          }
          if(res.data.store_list){
            this.$func.setLocal('store_list', JSON.stringify(res.data.store_list));
          }
        }
        callback ? callback() : '';
      }).catch(()=>{
        callback ? callback() : '';
      })
    },
    getAccess(){
      // if(!this.$func.getLocal('node_v1')){
        this.$api.getAccess({}).then((res)=>{
          if(res.data){
            this.$func.setLocal('node_v1',JSON.stringify(res.data));
            let grade = parseInt(this.$func.getLocal('grade'));
            if(grade === 9){
              window.location.href = "/#/user";
            }else if([3,4,5,8,13].includes(grade)){
              window.location.href = "/#/home";
            }else if([10,11].includes(grade)){
              window.location.href = "/#/factory";
            }else if(grade === 7){
              window.location.href = "/#/driver";
            }else{
              window.location.href = "/#/user";
            }
          }
        })
      // }
    },
    out(){
      // this.$func.confirm('确认退出账号？','温馨提示',()=>{
        this.$api.out({}).then((res)=>{
          this.$func.setLocal('node_v1','');
          this.$func.setLocal('grade','');
          this.$func.setLocal('cid','');
          this.$router.push({path:'/login'})
        })
      // })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/login.vue